import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';
import * as XLSX from 'xlsx';

function RevendaConsultasEmpresasPage({ usuario, empresaSelecionada, handleVoltar, handleSair }) {
  const [empresas, setEmpresas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (empresaSelecionada?.id) {
      const fetchEmpresas = async () => {
        setCarregando(true);
        try {
          const res = await fetch(`${API_URL}/pessoas?revenda_id=${empresaSelecionada.id}&todas=true`);
          const data = await res.json();
          setEmpresas(Array.isArray(data) ? data : []);
        } catch {
          setEmpresas([]);
        }
        setCarregando(false);
      };
      fetchEmpresas();
    }
  }, [empresaSelecionada]);

  const exportar = () => {
    const wsData = [
      ['ID', 'Nome Fantasia', 'Razão Social', 'Documento', 'E-mail', 'Telefone'],
      ...empresas.map(e => [
        e.id,
        e.fantasia,
        e.razao,
        e.documento,
        e.email,
        e.telefone
      ])
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Empresas');
    XLSX.writeFile(wb, 'empresas.xlsx');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresaSelecionada} onVoltar={handleVoltar} onSair={handleSair} />
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-5xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-4">Empresas</h2>
          <button onClick={exportar} className="bg-green-600 text-white px-4 py-2 rounded font-semibold hover:bg-green-700 transition mb-4 self-end">Exportar para Excel</button>
          <div className="w-full overflow-x-auto">
            <table className="min-w-full text-sm text-center border">
              <thead>
                <tr className="bg-blue-50">
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Nome Fantasia</th>
                  <th className="px-2 py-1">Razão Social</th>
                  <th className="px-2 py-1">Documento</th>
                  <th className="px-2 py-1">E-mail</th>
                  <th className="px-2 py-1">Telefone</th>
                </tr>
              </thead>
              <tbody>
                {carregando ? (
                  <tr><td colSpan={6} className="py-8 text-center">Carregando...</td></tr>
                ) : empresas.length === 0 ? (
                  <tr><td colSpan={6} className="py-8 text-center text-gray-500">Nenhuma empresa encontrada.</td></tr>
                ) : (
                  empresas.map(e => (
                    <tr key={e.id} className="border-b">
                      <td>{e.id}</td>
                      <td>{e.fantasia}</td>
                      <td>{e.razao}</td>
                      <td>{e.documento}</td>
                      <td>{e.email}</td>
                      <td>{e.telefone}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RevendaConsultasEmpresasPage; 